/**************************************************************
*  custom.js
*  サンリオ越境ECサイトテーマ用のカスタムJavaScript
**************************************************************/

// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', function() {
  // ページトップスクロール機能
  const pageTopButton = document.querySelector('.footer-page-top');
  if (pageTopButton) {
    pageTopButton.addEventListener('click', function(e) {
      e.preventDefault();
      // カスタムスムーズスクロールでページトップに移動
      smoothScrollToTop();
    });
  }

  // サイドメニューの初期状態でtabindexを設定
  initializeSidebarMenuTabindex();
});

/**
 * サイドメニューの初期状態でtabindexを設定
 */
function initializeSidebarMenuTabindex() {
  const sidebarMenuItems = document.querySelectorAll('.category-menu-item.has-submenu');

  sidebarMenuItems.forEach(item => {
    const submenu = item.querySelector('.category-menu-submenu');
    const submenuLinks = submenu ? submenu.querySelectorAll('[data-submenu-link]') : [];

    if (item.classList.contains('open')) {
      // 既に開いている子メニューのリンクはtabキー操作を有効にする
      submenuLinks.forEach(link => {
        link.setAttribute('tabindex', '0');
      });
    } else {
      // 閉じている子メニューのリンクはtabキー操作から除外する
      submenuLinks.forEach(link => {
        link.setAttribute('tabindex', '-1');
      });
    }
  });
}

/**
 * カスタムスムーズスクロールでページトップに移動
 */
function smoothScrollToTop() {
  const startPosition = window.pageYOffset;
  const distance = -startPosition;
  const duration = 800; // アニメーション時間（ミリ秒）
  let start = null;

  function animation(currentTime) {
    if (start === null) start = currentTime;
    const timeElapsed = currentTime - start;
    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}
/**
 * イージング関数（easeInOutQuad）
 */
function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
}







// 汎用的なトグル開閉関数
function initializeAccordion(options) {
  const {
    containerSelector,      // コンテナ要素のセレクタ
    itemSelector,          // 個別アイテムのセレクタ
    triggerSelector,       // トリガー要素のセレクタ（クリック対象）
    contentSelector,       // コンテンツ要素のセレクタ（開閉対象）
    toggleButtonSelector,  // トグルボタンのセレクタ（オプション）
    openClass = 'is-open', // 開いている状態のクラス名
    globalFlag,            // 重複実行防止用のグローバルフラグ名
    itemDataFlag,          // アイテム初期化済みフラグ名
    animationDuration = '0.3s', // アニメーション時間
    onToggle = null        // トグル時のコールバック関数
  } = options;

  // 重複実行を防ぐ
  if (window[globalFlag]) {
    return;
  }
  window[globalFlag] = true;

  // DOMContentLoadedイベントに依存しない実行関数
  const executeAccordion = function() {
    const containers = document.querySelectorAll(containerSelector);

    containers.forEach(container => {
      const items = container.querySelectorAll(itemSelector);

      items.forEach(item => {
        // 既に初期化済みの場合はスキップ
        if (item.dataset[itemDataFlag] === 'true') {
          return;
        }

        const trigger = item.querySelector(triggerSelector);
        const content = item.querySelector(contentSelector);
        const toggleButton = toggleButtonSelector ? item.querySelector(toggleButtonSelector) : null;

        if (trigger && content) {
          // 高さ取得とアニメーション用の初期設定
          content.style.maxHeight = '0px';
          content.style.overflow = 'hidden';
          content.style.transition = `max-height ${animationDuration} ease`;

          // 初期状態でopenクラスがある場合は開いた状態に設定
          if (item.classList.contains(openClass)) {
            // 少し遅延を入れてからscrollHeightを再計算し、確実にすべてのコンテンツが表示されるようにする
            setTimeout(function() {
              // 一度max-heightをnoneにして正確なscrollHeightを取得
              content.style.maxHeight = 'none';
              // 強制的に再描画を促す
              content.offsetHeight;
              const calculatedHeight = content.scrollHeight;
              if (calculatedHeight > 0) {
                // 余裕を持たせて設定（+100pxの余裕）
                content.style.maxHeight = (calculatedHeight + 100) + 'px';
              } else {
                // scrollHeightが取得できない場合は、十分に大きな値を設定
                content.style.maxHeight = '5000px';
              }
            }, 100);
          }

          // 再初期化時は古いイベントリスナーを削除
          if (window.reinitializeFilterTogglesExecuting) {
            // 古いイベントリスナーを削除するため、新しい要素をクローン
            const newTrigger = trigger.cloneNode(true);
            trigger.parentNode.replaceChild(newTrigger, trigger);

            // 新しいトリガー要素を取得
            const newTriggerElement = item.querySelector(triggerSelector);

            // フィルターセクションは常に閉じた状態から開始
            // item.classList.remove(openClass);

            // クリック処理
            const handleClick = function(e) {
              e.preventDefault();
              e.stopPropagation();

              // 開閉状態の切り替え
              const isOpen = item.classList.contains(openClass);

              if (isOpen) {
                // 閉じる処理
                // まず現在の高さを取得してからmax-heightを設定
                const currentHeight = content.scrollHeight;
                content.style.maxHeight = currentHeight + 'px';

                // 強制的に再描画を促す
                content.offsetHeight;

                // アニメーションで閉じる
                setTimeout(() => {
                  content.style.maxHeight = '0px';
                  item.classList.remove(openClass);
                }, 10);

                console.log('フィルターを閉じました:', item);
                // コールバック関数を呼び出し
                if (onToggle && content) {
                  onToggle(false, content);
                }
              } else {
                // 開く処理
                content.style.maxHeight = content.scrollHeight + 'px';
                item.classList.add(openClass);

                // アニメーション完了後にmax-heightをnoneに設定
                setTimeout(() => {
                  content.style.maxHeight = 'none';
                }, parseFloat(animationDuration) * 1000);

                console.log('フィルターを開きました:', item);
                console.log('is-openクラスが適用されているか:', item.classList.contains('is-open'));
                // コールバック関数を呼び出し
                if (onToggle && content) {
                  onToggle(true, content);
                }
              }
            };

            // 新しいクリックイベントを追加
            newTriggerElement.addEventListener('click', handleClick);

            // キーボードイベントを追加（Space または Enter キー）
            newTriggerElement.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClick(e);
              }
            });

            if (toggleButton) {
              const newToggleButton = item.querySelector(toggleButtonSelector);
              if (newToggleButton) {
                newToggleButton.addEventListener('click', handleClick);
                newToggleButton.addEventListener('keydown', function(e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick(e);
                  }
                });
              }
            }
          } else {
            // 初回初期化時
            // フィルターセクションは常に閉じた状態から開始
            // item.classList.remove(openClass);

            // クリック処理
            const handleClick = function(e) {
              e.preventDefault();
              e.stopPropagation();

              // 開閉状態の切り替え
              const isOpen = item.classList.contains(openClass);

              if (isOpen) {
                // 閉じる処理
                // まず現在の高さを取得してからmax-heightを設定
                const currentHeight = content.scrollHeight;
                content.style.maxHeight = currentHeight + 'px';

                // 強制的に再描画を促す
                content.offsetHeight;

                // アニメーションで閉じる
                setTimeout(() => {
                  content.style.maxHeight = '0px';
                  item.classList.remove(openClass);
                }, 10);

                console.log('フィルターを閉じました:', item);
                // コールバック関数を呼び出し
                if (onToggle && content) {
                  onToggle(false, content);
                }
              } else {
                // 開く処理
                content.style.maxHeight = content.scrollHeight + 'px';
                item.classList.add(openClass);

                // アニメーション完了後にmax-heightをnoneに設定
                setTimeout(() => {
                  content.style.maxHeight = 'none';
                }, parseFloat(animationDuration) * 1000);

                console.log('フィルターを開きました:', item);
                console.log('is-openクラスが適用されているか:', item.classList.contains('is-open'));
                // コールバック関数を呼び出し
                if (onToggle && content) {
                  onToggle(true, content);
                }
              }
            };

            // クリックイベントを追加
            trigger.addEventListener('click', handleClick);

            // キーボードイベントを追加（Space または Enter キー）
            trigger.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClick(e);
              }
            });

            if (toggleButton) {
              toggleButton.addEventListener('click', handleClick);
              toggleButton.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleClick(e);
                }
              });
            }

            // 初期化済みマークを設定
            item.dataset[itemDataFlag] = 'true';
          }
        }
      });
    });
  };

  // DOMContentLoadedイベントが既に発生している場合は即座に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', executeAccordion);
  } else {
    executeAccordion();
  }
}

// ドロワーメニューの開閉機能
initializeAccordion({
  containerSelector: '.menu-drawer',
  itemSelector: '.menu-drawer__menu li.has-children',
  triggerSelector: '.menu-drawer-toggle',
  contentSelector: '.has-children .submenu',
  openClass: 'is-open',
  globalFlag: 'menuDrawerInitialized',
  itemDataFlag: 'menuDrawerInitialized',
  // onToggle: function(isOpen, contentElement) {
  //   // すべてのサブメニューに対して特別な処理
  //   if (contentElement.classList.contains('submenu')) {
  //     if (isOpen) {
  //       contentElement.style.maxHeight = '3000px'; // より大きな高さを設定
  //     } else {
  //       contentElement.style.maxHeight = '0';
  //     }
  //   }
  // }
});

// ドロワーメニューのサブメニューの開閉機能
initializeAccordion({
  containerSelector: '.menu-drawer',
  itemSelector: '.menu-drawer__menu li.has-grandchildren',
  triggerSelector: '.menu-drawer-toggle',
  contentSelector: '.has-grandchildren .sub-submenu',
  openClass: 'is-open',
  globalFlag: 'subMenuDrawerInitialized',
  itemDataFlag: 'subMenuDrawerInitialized',
  // onToggle: function(isOpen, contentElement) {
  //   // すべてのサブサブメニューに対して特別な処理
  //   if (contentElement.classList.contains('sub-submenu')) {
  //     if (isOpen) {
  //       contentElement.style.maxHeight = '2000px'; // 孫リンク用の高さを設定
  //     } else {
  //       contentElement.style.maxHeight = '0';
  //     }
  //   }
  // }
});

// 商品情報の開閉機能
initializeAccordion({
  containerSelector: '.product__info-wrapper',
  itemSelector: '.product-details',
  triggerSelector: '.product-details__title-wrapper',
  contentSelector: '.product-details__content-wrapper',
  toggleButtonSelector: '.product-details__toggle',
  openClass: 'is-open',
  globalFlag: 'productDetailsInitialized',
  itemDataFlag: 'productDetailsInitialized'
});

// 絞り込みメニューの開閉機能
initializeAccordion({
  containerSelector: '.mobile-facets__main',
  itemSelector: '.filter-container',
  triggerSelector: '.mobile-facets__summary-header',
  contentSelector: '.mobile-facets__summary-inner',
  openClass: 'is-open',
  globalFlag: 'mobileFacetsInitialized',
  itemDataFlag: 'mobileFacetsInitialized'
});

// サイドメニューの開閉機能
initializeAccordion({
  containerSelector: '.category-menu',
  itemSelector: '.category-menu-item.has-submenu',
  triggerSelector: '.category-menu-toggle',
  contentSelector: '.category-menu-submenu',
  openClass: 'open',
  globalFlag: 'sidebarMenuInitialized',
  itemDataFlag: 'sidebarMenuInitialized',
  onToggle: function(isOpen, contentElement) {
    // 子メニューの開閉時にtabindexを制御
    const submenuLinks = contentElement.querySelectorAll('[data-submenu-link]');
    submenuLinks.forEach(link => {
      if (isOpen) {
        // 子メニューが開いている時はtabキー操作を有効にする
        link.setAttribute('tabindex', '0');
      } else {
        // 子メニューが閉じている時はtabキー操作から除外する
        link.setAttribute('tabindex', '-1');
      }
    });
  }
});


// FAQの開閉機能
initializeAccordion({
  containerSelector: '.faq',
  itemSelector: '.faq-item',
  triggerSelector: '.faq-item__question-wrapper',
  contentSelector: '.faq-item__answer-wrapper',
  toggleButtonSelector: '.faq-item__toggle',
  openClass: 'is-open',
  globalFlag: 'faqInitialized',
  itemDataFlag: 'faqInitialized'
});

// カテゴリメニューの開閉機能
initializeAccordion({
  containerSelector: '.catmenu-section',
  itemSelector: '.catmenu-item.has-children',
  triggerSelector: '.catmenu-row',
  contentSelector: '.catmenu-sub',
  openClass: 'is-open',
  globalFlag: 'catmenuInitialized',
  itemDataFlag: 'catmenuInitialized',
  onToggle: function(isOpen, contentElement) {
    // PC表示時（750px以上）は常に表示
    if (window.innerWidth > 749) {
      contentElement.style.maxHeight = 'none';
      contentElement.style.overflow = 'visible';
    }
  }
});

// PC表示時にサブメニューを常に表示する関数
function updateCatmenuForDesktop() {
  const catmenuItems = document.querySelectorAll('.catmenu-item.has-children');
  catmenuItems.forEach(function(item) {
    const submenu = item.querySelector('.catmenu-sub');
    if (submenu) {
      if (window.innerWidth > 749) {
        // PC表示時：常に表示
        item.classList.add('is-open');
        submenu.style.maxHeight = 'none';
        submenu.style.overflow = 'visible';
        // aria-expanded属性も同期
        const btn = item.querySelector(':scope > .catmenu-row > .catmenu-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      } else {
        // スマホ表示時：アニメーション用の設定を維持
        if (!item.classList.contains('is-open')) {
          submenu.style.maxHeight = '0px';
          submenu.style.overflow = 'hidden';
        }
      }
    }
  });
}

// 初期化時とリサイズ時に実行
// DOMContentLoadedイベントで実行（initializeAccordionの初期化完了後）
document.addEventListener('DOMContentLoaded', function() {
  // 少し遅延させて、initializeAccordionの初期化が完了するのを待つ
  setTimeout(updateCatmenuForDesktop, 100);
});
window.addEventListener('resize', updateCatmenuForDesktop);

// フッターメニューの開閉機能（汎用関数を使用）
initializeAccordion({
  containerSelector: '.footer-blocks-menu',
  itemSelector: '.footer-blocks-menu__group--1',
  triggerSelector: '.footer-blocks-menu__title',
  contentSelector: '.footer-blocks-menu-list-1',
  openClass: 'is-active',
  globalFlag: 'footerMenuInitialized',
  itemDataFlag: 'footerMenuInitialized',
  animationDuration: '0.3s'
});
// ウィンドウリサイズ時の処理
window.addEventListener('resize', function() {
  // PC表示時（幅750px以上）のみフッターメニューを常に表示する
  if (window.innerWidth > 749) {

    // .footer-blocks-menu__group--1に.is-activeが付いていない場合のみクリックイベントを発火させる
    const group1 = document.querySelector('.footer-blocks-menu__group--1');
    if (group1 && !group1.classList.contains('is-active')) {
      const triggers = group1.querySelectorAll('.footer-blocks-menu__title');
      triggers.forEach(function(trigger) {
        trigger.click();
      });
    }
  }
  // スマホ表示時（幅749px以下）は何もしない
});
